export default 'icon--youtube';